/**
 * Houdt paginatitels binnen de breedte die Google in de zoekresultaten laat
 * zien. Wij korten nooit op zoekwoorden: alleen het merk- of claimsuffix
 * achteraan verdwijnt wanneer de titel anders wordt afgekapt. Blijft de titel
 * daarna nog te lang, dan laten wij hem staan (inhoud gaat voor tekenaantal).
 */
const TRIMMABLE_SUFFIXES = [
  " | Taxiritje.nl",
  " | Taxiritje",
  " | Fixed price",
  " | Fixed prices",
  " | Vaste prijs",
  " | Vaste prijzen",
  " | Voordelige vaste prijs",
];

/** Richtlijn: circa 60 tekens blijft in de zoekresultaten volledig zichtbaar. */
const MAX_TITLE = 60;

export function seoTitle(title: string, max: number = MAX_TITLE): string {
  const text = title.trim();
  if (text.length <= max) return text;

  for (const suffix of TRIMMABLE_SUFFIXES) {
    if (!text.endsWith(suffix)) continue;
    const shortened = text.slice(0, -suffix.length).trim().replace(/[|·,;:\s-]+$/, "");
    // Alleen inkorten als er een volwaardige, beschrijvende titel overblijft.
    if (shortened.length >= 20) return shortened;
  }

  return text;
}
